import cx from 'clsx';
import { IconEyeFilled } from '@common-web/icons/index.jsx';
import React from 'react';

const ViewIcon = ({ ctaText, className, isEditForm = false, handleViewClick }) => {
  return (
    <div
      className={cx(className, 'flex flexYcenter cursorPointer')}
      style={{ color: 'var(--ant-color-primary)', gap: 4 }}
      onClick={isEditForm ? handleViewClick : () => {}}
    >
      {ctaText}
      <IconEyeFilled size={14} color="#A4B4B6" />
    </div>
  );
};

export default ViewIcon;
